import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/display/Home.vue"),
  },
  {
    path: "/quotation",
    name: "quotation",
    component: () => import("../views/display/Quotation.vue"),
  },
  {
    path: "/purchaseOrder",
    name: "purchaseOrder",
    component: () => import("../views/display/PurchaseOrder.vue"),
  },
  {
    path: "/invoice",
    name: "invoice",
    component: () => import("../views/display/Invoice.vue"),
  },
  {
    path: "/expenses",
    name: "expenses",
    component: () => import("../views/display/Expenses.vue"),
  },
  {
    path: "/receipt",
    name: "receipt",
    component: () => import("../views/display/Receipt.vue"),
  },
  {
    path: "/taxInvoice",
    name: "taxInvoice",
    component: () => import("../views/display/TaxInvoice.vue"),
  },
  {
    path: "/dailyJournal",
    name: "dailyJournal",
    component: () => import("../views/display/DailyJournal.vue"),
  },
  {
    path: "/billingNote",
    name: "billingNote",
    component: () => import("../views/display/BillingNote.vue"),
  },
  {
    path: "/combinePaymentNote",
    name: "combinePaymentNote",
    component: () => import("../views/display/CombinePaymentNote.vue"),
  },
  {
    path: "/creditNote",
    name: "creditNote",
    component: () => import("../views/display/CreditNote.vue"),
  },
  {
    path: "/creditNoteExpense",
    name: "creditNoteExpense",
    component: () => import("../views/display/CreditNoteExpense.vue"),
  },
  {
    path: "/debitNote",
    name: "debitNote",
    component: () => import("../views/display/DebitNote.vue"),
  },
  {
    path: "/debitNoteExpense",
    name: "debitNoteExpense",
    component: () => import("../views/display/DebitNoteExpense.vue"),
  },
  {
    path: "/withholdingTax",
    name: "withholdingTax",
    component: () => import("../views/display/WithholdingTax.vue"),
  },
  {
    path: "/pp30",
    name: "pp30",
    component: () => import("../views/display/PP30.vue"),
  },
  {
    path: "/pnd1",
    name: "pnd1",
    component: () => import("../views/display/Pnd1.vue"),
  },
  {
    path: "/pnd2",
    name: "pnd2",
    component: () => import("../views/display/Pnd2.vue"),
  },
  {
    path: "/pnd3",
    name: "pnd3",
    component: () => import("../views/display/Pnd3.vue"),
  },
  {
    path: "/pnd53",
    name: "pnd53",
    component: () => import("../views/display/Pnd53.vue"),
  },
  {
    path: "/pnd1Item",
    name: "pnd1Item",
    component: () => import("../views/display/Pnd1Item.vue"),
  },
  {
    path: "/pnd2Item",
    name: "pnd2Item",
    component: () => import("../views/display/Pnd2Item.vue"),
  },
  {
    path: "/pnd3Item",
    name: "pnd3Item",
    component: () => import("../views/display/Pnd3Item.vue"),
  },
  {
    path: "/pnd53Item",
    name: "pnd53Item",
    component: () => import("../views/display/Pnd53Item.vue"),
  },
  {
    path: "/salesTaxInvoiceItem",
    name: "salesTaxInvoiceItem",
    component: () => import("../views/display/PP30Transaction.vue"),
  },
  {
    path: "/purchasesTaxInvoiceItem",
    name: "purchasesTaxInvoiceItem",
    component: () => import("../views/display/PP30Transaction.vue"),
  },
  {
    path: "/envelope",
    name: "envelope",
    component: () => import("../views/display/Envelope.vue"),
  },
  {
    path: "/executiveSummary",
    name: "executiveSummary",
    component: () => import("../views/display/ExecutiveSummary.vue"),
  },
  {
    path: "/requestTaxInvoice",
    name: "requestTaxInvoice",
    component: () => import("../views/display/RequestTaxInvoice.vue"),
  },
  {
    path: "/pages",
    name: "pages",
    component: () => import("@/views/pages/Pages.vue"),
    children: [
      {
        path: "sessionExpire",
        name: "sessionExpire",
        component: () => import("@/views/pages/PagesChildren/SessionExpire.vue"),
      },
      {
        path: "404",
        name: "pageNotFound",
        component: () => import("@/views/pages/PagesChildren/PageNotFound.vue"),
      },
    ],
  },
  { path: "*", redirect: "/pages/404" },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
